import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shared } from '../shared';
import Card from '@components-clean/core/card';
import { InfoField } from '@components-clean/core/info-field';

interface IProps {
    message: string;
}
const EmptyInfo = ({ message }: IProps) => {
    const { t } = useTranslation('admin', { keyPrefix: 'managePanels.panelDetails.empty' });

    return (
        <Card
            title={t('title')}
            className={Shared.className}
            data-testid={Shared.dataTestId}
            bodyStyles={{ display: 'grid' }}
        >
            <InfoField type="Info" message={message} data-testid="panel-details-info" />
        </Card>
    );
};

export default EmptyInfo;
